import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { WORKER_URL, getAuthHeaders } from '../../utils/api';

export function useSubscription() {
  const [sub, setSub] = useState(null);

  const fetchSub = () => {
    fetch(`${WORKER_URL}/api/user/subscription`, { headers: getAuthHeaders() })
      .then(r => r.ok ? r.json() : null)
      .then(data => { if (data) setSub(data); })
      .catch(() => {});
  };

  useEffect(() => {
    fetchSub();
    const interval = setInterval(fetchSub, 30000);
    return () => clearInterval(interval);
  }, []);

  return { sub, refreshSub: fetchSub };
}

export default function SubscriptionBanner({ sub }) {
  const navigate = useNavigate();

  if (!sub || sub.status === 'active') return null;

  if (sub.status === 'trial') {
    const price = sub.isEarlyAdopter ? 'R$ 34,93' : 'R$ 49,90';
    return (
      <div style={{
        position: 'fixed', top: 0, left: 0, right: 0, zIndex: 1500,
        backgroundColor: '#2D3277', padding: '8px 20px',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        gap: '8px',
      }}>
        <span style={{ fontSize: '15px' }}>🎉</span>
        <span style={{ color: 'white', fontWeight: 500, fontSize: '0.88rem' }}>
          Você está no período gratuito — <strong>{sub.trialDaysLeft} dia{sub.trialDaysLeft !== 1 ? 's' : ''} restante{sub.trialDaysLeft !== 1 ? 's' : ''}</strong>. Após o trial, {price}/mês{sub.isEarlyAdopter ? ' · 30% desconto fundador' : ''}.
        </span>
      </div>
    );
  }

  if (sub.status === 'blocked') {
    return (
      <div style={{
        position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.85)',
        zIndex: 2000, display: 'flex', alignItems: 'center', justifyContent: 'center',
      }}>
        <div style={{ backgroundColor: 'white', borderRadius: '12px', padding: '40px', maxWidth: '440px', textAlign: 'center', boxShadow: '0 20px 60px rgba(0,0,0,0.4)' }}>
          <div style={{ fontSize: '48px', marginBottom: '16px' }}>🔒</div>
          <h2 style={{ color: '#cc0000', marginBottom: '8px' }}>Acesso Bloqueado</h2>
          <p style={{ color: '#555', lineHeight: '1.6', marginBottom: '24px' }}>
            Sua assinatura está com pagamento em atraso há <strong>{sub.daysOverdue} dias</strong>.<br />
            Regularize para retomar o acesso imediatamente.
          </p>
          <button
            onClick={() => navigate('/billing')}
            style={{ width: '100%', padding: '13px', backgroundColor: '#2D3277', color: 'white', border: 'none', borderRadius: '8px', fontSize: '1rem', fontWeight: 600, cursor: 'pointer' }}
          >
            Pagar agora — {sub.isEarlyAdopter ? 'R$ 34,93' : 'R$ 49,90'}
          </button>
        </div>
      </div>
    );
  }

  if (sub.status === 'warning') {
    return (
      <div style={{
        position: 'fixed', top: 0, left: 0, right: 0, zIndex: 1500,
        backgroundColor: '#f59e0b', padding: '10px 20px',
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <span style={{ fontSize: '18px' }}>⚠️</span>
          <span style={{ color: '#7c2d12', fontWeight: 600, fontSize: '0.9rem' }}>
            Pagamento em atraso — sua conta será bloqueada em <strong>{sub.daysUntilBlock} dia{sub.daysUntilBlock !== 1 ? 's' : ''}</strong>. Vencimento: {sub.dueDate}
          </span>
        </div>
        <button
          onClick={() => navigate('/billing')}
          style={{ backgroundColor: '#7c2d12', color: 'white', border: 'none', borderRadius: '6px', padding: '6px 14px', fontWeight: 600, cursor: 'pointer', fontSize: '0.85rem', whiteSpace: 'nowrap' }}
        >
          Regularizar
        </button>
      </div>
    );
  }

  return null;
}
